import Application from 'components/Application';
import Layout from 'components/Layout';
import React from "react";

const ApplicationPage = () => {
  return (
    <Layout>
      <Application />
    </Layout>
  );
};

export default ApplicationPage;